'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _VisibilitySensor = require('./components/VisibilitySensor.component');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_VisibilitySensor).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/base-visibility-sensor/lib/index.js
// module id = 1365
// module chunks = 1